/**
 * Hook for managing the hot and cold game and background toggle state
 */

import { useMemo, useState } from 'react';

import { HOT_AND_COLD_SECTION_NAME, SECTION_NAMES } from '@repo/common';
import type ISectionSettings from 'types/models/ISectionSettings';

export const useHotColdToggle = (data: ISectionSettings) => {
  const [isColdSelected, setIsColdSelected] = useState(false);

  const displayGames = useMemo(() => {
    if (data.name !== HOT_AND_COLD_SECTION_NAME || !data.hotColdSettings) {
      return data.games;
    }

    return isColdSelected ? data.hotColdSettings.coldGames : data.hotColdSettings.hotGames;
  }, [data, isColdSelected]);

  const backgroundSourceName = useMemo(() => {
    if (data.name !== HOT_AND_COLD_SECTION_NAME || !data.hotColdSettings) {
      return data.name;
    }

    return isColdSelected ? SECTION_NAMES.COLD_GAMES : SECTION_NAMES.HOT_GAMES;
  }, [data, isColdSelected]);

  return { isColdSelected, setIsColdSelected, displayGames, backgroundSourceName };
};
